import { pxToRem } from "../typography"

export default function Tooltip(theme) {
  const isLight = theme.palette.mode === "light"

  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[isLight ? 800 : 700],
          boxShadow: theme.shadows[6],
          fontSize: pxToRem(13),
          fontWeight: theme.typography.fontWeightRegular,
          padding: theme.spacing(0.75, 1.5),
        },
        arrow: {
          color: theme.palette.grey[isLight ? 800 : 700],
        },
      },
    },
  }
}
